export const errorCode = {
  NotAuthorized: 401,
  AccessDenied: 200013,
  NetworkError: -8,
  CancelRequest: -1,
  LimitExceeded: 700015,
  GeneralError: 500
};
